import { format } from 'date-fns'
import { Calendar as CalendarIcon, ChevronDown } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from 'components/UI/popover'
import { Calendar } from 'components/UI/calendar'

export type DateRangeValue = { from: Date; to?: Date } | undefined

/** Reusable date range picker with Popover + Calendar. */
export function DateRangePicker({
  value,
  onChange,
}: {
  value: DateRangeValue
  onChange: (range: DateRangeValue) => void
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex-1 flex items-center gap-2 px-3.5 min-h-[38px] bg-surface border border-line rounded-md text-sm text-fg hover:border-brand transition-colors">
          <CalendarIcon className="w-4 h-4 flex-shrink-0" />
          <span className="flex-1 text-left">
            {value?.from ? (
              value.to ? (
                <>
                  {format(value.from, 'd MMM yyyy')} -{' '}
                  {format(value.to, 'd MMM yyyy')}
                </>
              ) : (
                format(value.from, 'd MMM yyyy')
              )
            ) : (
              'All time'
            )}
          </span>
          <ChevronDown className="w-4 h-4 flex-shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          initialFocus
          mode="range"
          defaultMonth={value?.from}
          selected={value}
          onSelect={(newRange) => {
            if (!newRange?.from) return
            onChange(newRange as { from: Date; to?: Date })
          }}
          numberOfMonths={2}
        />
        {value && (
          <div className="p-3 border-t">
            <button
              onClick={() => onChange(undefined)}
              className="w-full px-3 py-1.5 text-sm text-fg-secondary hover:text-brand transition-colors"
            >
              Clear dates
            </button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  )
}
